import React, { Component } from "react";
import { Outlet } from "react-router-dom";
import AppHeader from "../AppHeader/AppHeader";
import Footer from "../Footer/Footer";
import "./MarketingLayout.scss";

interface MarketingLayoutProps {}

interface MarketingLayoutState {}

class MarketingLayout extends Component<MarketingLayoutProps, MarketingLayoutState> {
  constructor(props: MarketingLayoutProps) {
    super(props);
    this.state = {};
  }

  render(): React.JSX.Element {
    return (
      <div className="marketing-layout">
        <AppHeader variant="marketing" />
        <main className="app-main">
          <Outlet />
        </main>
        <Footer />
      </div>
    );
  }
}

export default MarketingLayout;
